export interface BaseToolEngineInterface {
}

export type ToolEngineInterfaceToken<TInterface extends BaseToolEngineInterface> = Readonly<{
	id: string
	_interface?: TInterface
}>

export function createToolEngineInterfaceToken<TInterface extends BaseToolEngineInterface>(id: string): ToolEngineInterfaceToken<TInterface> {
	return Object.freeze({id}) as ToolEngineInterfaceToken<TInterface>
}

export function getToolEngineInterfaceIds(interfaces: readonly ToolEngineInterfaceToken<BaseToolEngineInterface>[] = []): string[] {
	return interfaces.map(engineInterface => engineInterface.id)
}

export function hasRequiredEngineInterfaces(
	implementedInterfaceIds: readonly string[] = [],
	requiredInterfaceIds: readonly string[] = [],
): boolean {
	let implementedInterfaceIdSet = new Set(implementedInterfaceIds)
	return requiredInterfaceIds.every(interfaceId => implementedInterfaceIdSet.has(interfaceId))
}
